import cx from 'classnames'
import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Body1, Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS, LITERAL_KEYS} from './config.js'

const ALIGNMENTS = {
  CENTER: 'Center',
  END: 'End',
  START: 'Start'
}

// The coachmark and the highlighted label lean towards the side of the bar they point at,
// so they stay inside the drawer on the outermost ranks
const getAlignment = index => {
  if (index < 2) return ALIGNMENTS.START
  if (index > 2) return ALIGNMENTS.END
  return ALIGNMENTS.CENTER
}

const Indicator = ({average, averageLabel, highlightedIndex, price, ranks}) => {
  const {i18n} = useSuiContext()

  const alignment = getAlignment(highlightedIndex)
  const highlightedRank = ranks[highlightedIndex].label.toLowerCase()
  const ranksBarLabel = i18n.t(LITERAL_KEYS.SCALE_DESCRIPTION, {
    position: highlightedIndex + 1,
    rank: highlightedRank,
    total: ranks.length
  })

  return (
    <div className={`${BASE_CLASS}-indicator`}>
      <div className={cx(`${BASE_CLASS}-coachmark`, `${BASE_CLASS}-coachmark--align${alignment}`)}>
        <div className={`${BASE_CLASS}-coachmarkBox`}>
          <Body1 highlight>
            {i18n.t(LITERAL_KEYS.COACHMARK_RANK, {rank: highlightedRank})}
            {Boolean(price) && `: ${i18n.c(price)}`}
          </Body1>
          {Boolean(average) && (
            <Body1>
              {averageLabel}: {i18n.c(average)}
            </Body1>
          )}
        </div>
        <div
          className={cx(
            `${BASE_CLASS}-coachmarkArrow`,
            `${BASE_CLASS}-coachmarkArrow--position${highlightedIndex + 1}`
          )}
        />
      </div>

      <div aria-label={ranksBarLabel} className={`${BASE_CLASS}-bars`} role="img">
        {ranks.map(({color, label, value}, index) => {
          const isHighlighted = index === highlightedIndex

          return (
            <div
              className={cx(`${BASE_CLASS}-bar`, isHighlighted && `${BASE_CLASS}-bar--align${alignment}`)}
              key={value}
            >
              <span
                className={cx(
                  `${BASE_CLASS}-barTrack`,
                  `${BASE_CLASS}-barTrack--${color}`,
                  !isHighlighted && `${BASE_CLASS}-barTrack--dimmed`
                )}
              />
              {isHighlighted && <Body2 highlight>{label}</Body2>}
            </div>
          )
        })}
      </div>
    </div>
  )
}

Indicator.displayName = 'PriceIndicatorDrawerIndicator'

Indicator.propTypes = {
  average: PropTypes.number,
  averageLabel: PropTypes.string,
  highlightedIndex: PropTypes.number.isRequired,
  price: PropTypes.number,
  ranks: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.number
    })
  ).isRequired
}

export default Indicator
